import classNames from 'classnames';
import React from 'react';

import Icon from '@wetransfer/transfer/component/icon';
import Spinner from '@wetransfer/transfer/component/spinner';
import Browser from '@wetransfer/transfer/modules/concorde-browser/browser';
import I18n from '@wetransfer/transfer/modules/i18n';
import { Button } from '@wetransfer/transfer/oneui/react';

import styles from './Processing.module.scss';
import { ProcessingProps } from './types';

function Processing({ title, description }: ProcessingProps): JSX.Element {
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        {Browser.isMobile ? (
          <Spinner
            className={styles.spinner}
            circumference={64}
            stroke={4}
            hideText
            percentage={25}
            rotate
          />
        ) : (
          <Icon type="TransferProcessing" className={styles.ellipsisIcon} />
        )}
        <h2 className={styles.title}>{title || 'Nearly ready...'}</h2>
        <p className={styles.subtitle}>{description}</p>
      </div>
      {Browser.isMobile ? null : (
        <div className={classNames(styles.footer)}>
          <Button className={styles.button} disabled small>
            {I18n.t('transfer.buttons.download')}
          </Button>
        </div>
      )}
    </div>
  );
}

export default Processing;
